export default __webpack_public_path__ + "static/media/Group 127.86c168e1.svg";